/**
 * Zweck: Kapselt die Prüfung und Abfrage des AWEG-Import-Hinweises.
 */
import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Artikel} from '../models/artikel';
import {
  ImportHinweisDecision,
  ImportHinweisOption,
  ImportHinweisResult
} from '../models/import-hinweis';
import {
  ShopDialogsImportHinweisComponent
} from '../modules/shop/dialogs/import-hinweis/shop.dialogs.import-hinweis.component';

export {ImportHinweisDecision, ImportHinweisOption, ImportHinweisResult} from '../models/import-hinweis';

/**
 * Zweck: Stellt die gemeinsame Import-Hinweislogik für Add- und Update-Flows bereit.
 */
@Injectable({providedIn: 'root'})
export class AppImportHinweisService {
  /**
   * Beschreibt Methode constructor und ihren Rückgabevertrag.
   */
  constructor(private dialog: MatDialog) {
  }

  /**
   * Prüft, ob für Artikel und Menge eine neue Entscheidung erforderlich ist.
   */
  static needsDecision(artikel: Artikel | any, menge: number, consent: boolean): boolean {
    return String(artikel?.Artikelstamm || '').toUpperCase() === 'DE' && Number(menge) > 3 && consent !== true;
  }

  /**
   * Liefert die absolute Zielmenge nach Ablehnung des Import-Hinweises.
   */
  static targetAmountAfterReduction(): number {
    return 3;
  }

  /**
   * Öffnet den verpflichtenden Import-Hinweis-Dialog.
   */
  open(artikel: Artikel): Observable<ImportHinweisResult> {
    const ref = this.dialog.open(ShopDialogsImportHinweisComponent, {
      data: {artikel},
      disableClose: true,
      width: '900px',
      maxWidth: '95vw'
    });

    return ref.afterClosed().pipe(
      map((result: ImportHinweisResult | ImportHinweisDecision) => {
        if (typeof result === 'string') {
          return {decision: result};
        }

        return result?.decision === 'confirm'
          ? {decision: 'confirm', option: result.option}
          : {decision: 'reduce'};
      })
    );
  }
}
